 

<script>
import { Doughnut } from 'vue-chartjs'
export default( {
    extends: Doughnut,
    props: ['chartData', 'chartOptions'],
    data() {
        return {
        }
    },
    computed:{
    },
    mounted () {
        this.renderChart(this.chartData, this.chartOptions)
    },
})
</script>
<style scoped>
</style>